import React from "react";
import {
  Image,
  ImageBackground,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { RedChipsPng } from "../../../assets";

type Props = {
  name: string;

  chips: number;
  onOpen: () => void;
};

const MyTablesComponent = ({
  name,

  chips,
  onOpen,
}: Props) => {
  return (
    <ImageBackground
      // source={backgroundImage}
      resizeMode="stretch"
      style={styles.cardBackground}
    >
      <View style={styles.container}>
        {/* Name */}
        <View style={styles.nameWrapper}>
          <Text style={styles.nameText}>{name}</Text>
        </View>

        {/* Chips */}
        <View style={styles.chipsWrapper}>
          <View style={{ display: "flex", flexDirection: "row" }}>
            <Image
              source={RedChipsPng}
              resizeMode="contain"
              style={styles.chipsIcon}
            />
            <Text style={styles.chipsText}>{chips}</Text>
          </View>
          <TouchableOpacity style={styles.button} onPress={onOpen}>
            <Text style={styles.buttonText}>Open</Text>
          </TouchableOpacity>
        </View>
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  cardBackground: {
    backgroundColor: "#2a2126", // dark row bg
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 10,
    marginHorizontal: 16,
    marginBottom: 8,
  },
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  nameWrapper: {
    flex: 1.5,
  },
  nameText: {
    color: "#ffffff",
    fontSize: 18,
    fontWeight: "500",
    textTransform: "uppercase",
  },
  chipsWrapper: {
    flex: 1.5,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  chipsIcon: {
    width: 24,
    height: 24,
    marginRight: 8,
  },
  chipsText: {
    color: "#ffffff",
    fontSize: 18,
    fontWeight: "600",
  },
  button: {
    width: 90,
    height: 32,
    borderRadius: 6,
    backgroundColor: "#ffcf54", // golden
    justifyContent: "center",
    alignItems: "center",
    textTransform: "uppercase",
  },
  buttonText: {
    color: "#5b3c12",
    fontSize: 14,
    fontWeight: "700",
  },
});

export default MyTablesComponent;
